<template>
  <div>
    <CCol sm="12">
        <CCard>
            <CCardBody class="d-flex flex-column">
                <!-- Alerts -->
                <CCol sm="12">
                    <!-- Title -->
                    <CRow>
                        <CCol sm="12">
                            <label class="font-weight-bold">Alertas</label>
                        </CCol>
                    </CRow>
                    <!-- Existing alerts (with see more/less and remove options) -->
                    <CRow v-for="alert in alerts" :key="alert.key" class="d-flex justify-content-between mb-1 mt-1">
                      <CCol sm="9">
                        <span class="alert-text" v-bind:class="{'show-all': shownAlert == alert}">{{alert.text}}</span>
                      </CCol>
                      <CCol sm="3" class="d-flex justify-content-end button-container">
                        <CButton class="mr-1" color="primary" variant="outline" square size="sm" @click="onToggleSeeClicked(alert)">
                          {{ shownAlert == alert ? "Ver menos" : "Ver mais" }}
                        </CButton>
                        <CButton class="ml-1" color="primary" variant="outline" square size="sm" @click="onRemoveClicked(alert)">
                          Remover
                        </CButton>
                      </CCol>
                    </CRow>
                    <!-- Add new alert -->
                    <CRow class="mt-3">
                      <CCol sm="12">
                        <CTextarea placeholder="Novo alerta" vertical v-model="newAlert" rows="3" :is-valid="isNewAlertValid"/>
                      </CCol>
                    </CRow>
                    <!-- Action button -->
                    <CCol class="d-flex justify-content-end mt-3">
                        <CRow sm="2" class="align-self-end">
                            <CSpinner v-if="loadingAlerts" variant="success" small></CSpinner>
                            <CButton v-else type="button" class="btn btn-primary" @click="submitClicked">Submeter</CButton>
                        </CRow>
                    </CCol>
                </CCol>
                <hr/>
                <!-- Last day -->
                <CCol sm="12">
                    <!-- Title -->
                    <CRow>
                      <CCol sm="12">
                        <label class="font-weight-bold">{{lastOperationsTitle}}</label>
                      </CCol>
                    </CRow>
                    <!-- Operations -->
                    <CRow class="mb-3">
                      <CCol sm="12">
                        <label>Operações</label>
                        <CDataTable :striped="true" :bordered="true" :items="items" :fields="fields" @row-clicked="rowClicked" :loading="loadingOperations"></CDataTable>
                      </CCol>
                    </CRow>
                    <!-- Graphs -->
                    <CRow class="mt-3">
                      <CCol sm="6">
                        <!-- Tasks -->
                        <label>Tarefas</label>
                        <CChartBar class="chart mb-5" :datasets="tasksStats" :labels="tasksNames" :options="{ maintainAspectRatio: false }"/>
                      </CCol>
                      <CCol sm="6">
                        <!-- Places -->
                        <label>Lugares</label>
                        <CChartBar class="chart mb-5" :datasets="placesStats" :labels="placesNames" :options="{ maintainAspectRatio: false }"/>
                      </CCol>
                    </CRow>
                </CCol>
            </CCardBody>
        </CCard>
    </CCol>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { CChartBar  } from '@coreui/vue-chartjs'
import InputGetOperations from '@/classes/InputGetOperations';
import { UTILS_HELPER } from "@/helpers/utils.js";
import InputGetComparativeData from '@/classes/InputGetComparativeData';

export default {
  name: 'Dashboard',
  components: { CChartBar },
  data()
  {
    return {
      loadingAlerts: false,
      newAlert: '',
      isNewAlertValid: undefined,
      shownAlert: null,
      //
      loadingOperations: false,
      fields: [
        { key: 'readableDate', label: 'Data', _classes: 'font-weight-bold', sorter: true },
        { key: 'tasks', label: 'Tarefas', sorter: false },
        { key: 'places', label: 'Locais', sorter: false },
        { key: 'people', label: 'Recursos Humanos', sorter: false }
      ],
      //
      loadingComparativeData: false
    }
  },
  computed:
  {
    ...mapState({
      operationListOutput: state => state.operations.listOutput,
      messagesListOutput: state => state.messages.listOutput,
    }),
    ...mapState('operations', ['comparativeData']),
    ...mapState('messages', ['addMessageProgress']),
    ...mapState('messages', ['removeMessagesProgress']),
    alerts: function() {
      var result = [];
      if(this.messagesListOutput && this.messagesListOutput.obj)
      {
        result = this.messagesListOutput.obj.public;
      }

      return result;
    },
    operationsInfo: function(){
      return this.operationListOutput && this.operationListOutput.obj ? this.operationListOutput.obj : null;
    },
    items: function() {
      var result = null;

      if(this.operationsInfo)
      {
        result = this.operationsInfo.operations;

        result.forEach(operation => {
          operation["readableDate"] = UTILS_HELPER.formatDate(operation.date);
        });
      }

      return result;
    },
    startDate: function()
    {
      var today = new Date();
      var result = today;

      if(today.getDay() == 5) // Friday
      {
        result.setDate(today.getDate()-3);
      } 
      else
      {
        result.setDate(today.getDate()-1);
      }

      return UTILS_HELPER.formatDate(result);
    },
    endDate: function()
    {
      return UTILS_HELPER.formatDate(new Date());
    },
    lastOperationsTitle: function()
    {
      return `Últimas operações (${this.startDate}-${this.endDate})`;
    },
    comparativeDataInfo: function(){
      return this.comparativeData && this.comparativeData.obj ? this.comparativeData.obj : null;
    },
    tasksNames: function()
    {
      return this.comparativeDataInfo ? this.comparativeDataInfo.tasksStatistics.filter(stat => stat.hours > 0).map(stat => stat.name) : [];
    },
    tasksStats: function()
    {
      var result = 
      [
        {
          label: 'Horas',
          backgroundColor: 'rgb(228,102,81,0.9)',
        },
        {
          label: 'Custos',
          backgroundColor: 'rgb(0,216,255,0.9)',
        }
      ];

      if(this.comparativeDataInfo)
      {
        result[0]["data"] = this.comparativeDataInfo.tasksStatistics.filter(stat => stat.hours > 0).map(stat => stat.hours);
        result[1]["data"] = this.comparativeDataInfo.tasksStatistics.filter(stat => stat.hours > 0).map(stat => stat.cost.toFixed(2));
      }

      return result;
    },
    placesNames: function()
    {
      return this.comparativeDataInfo ? this.comparativeDataInfo.placesStatistics.filter(stat => stat.hours > 0).map(stat => stat.name) : [];
    },
    placesStats: function()
    {
      var result = 
      [
        {
          label: 'Horas',
          backgroundColor: 'rgb(228,102,81,0.9)',
        },
        {
          label: 'Custos',
          backgroundColor: 'rgb(0,216,255,0.9)',
        }
      ];

      if(this.comparativeDataInfo)
      {
        result[0]["data"] = this.comparativeDataInfo.placesStatistics.filter(stat => stat.hours > 0).map(stat => stat.hours);
        result[1]["data"] = this.comparativeDataInfo.placesStatistics.filter(stat => stat.hours > 0).map(stat => stat.cost.toFixed(2));
      }

      return result;
    },
  },
  mounted: function()
  {
    this.loadingOperations = true;

    // If it is Monday, get the tasks from the previous day into today. If it is another day, get the tasks from the day prior into today.
    var inputOp = new InputGetOperations(1, 999, this.startDate, this.endDate, null, null, null, null, 1);
    console.log(inputOp)
    this.getOperations(inputOp);

    this.loadingComparativeData = true;
    var inputCD = new InputGetComparativeData(this.startDate, this.endDate);
    
    this.getComparativeData(inputCD);
  },
  methods:{
    ...mapActions({
      'getMessages': 'messages/getList',
      'getOperations': 'operations/getList',
    }),
    ...mapActions('operations', ['getComparativeData']),
    ...mapActions('messages', ['addMessage']),
    ...mapActions('messages', ['removeMessages']),
    submitClicked(){
      this.submitted = true;
      // Emit event
      if(this.newAlert)
      {
        var input = new InputMessage(this.newAlert);
        this.addMessage(input);
      }
    },
    onRemoveClicked(alert)
    {
      if(confirm(`Tem a certeza que pretende remover o alerta selectionado?`))
      {
        this.removeMessages([alert.id]);
      }
    },
    onToggleSeeClicked(alert)
    {
      if(this.shownAlert == alert)
      {
        this.shownAlert = null;
      }
      else
      {
        this.shownAlert = alert;
      }
    },
    rowClicked (item, index) {
      this.$router.push({name: "ViewOperations", params: { id: item.id } });
    },
  },
  watch:
  {
    newAlert: function()
    {
      this.newAlertError = false;
    },
    addMessageProgress: function(val)
    {
      if(val === undefined)
      {
        this.loadingAlerts = true;
      }
      else
      {
        if(!val)
        {
          this.isNewAlertValid = false;
        }
        else
        {
          this.newAlert = '';
          this.getMessages();
        }

        this.loadingAlerts = false;
      }
    },
    removeMessagesProgress: function(val)
    {
      if(val)
      {
        this.getMessages();
      }
    }
  },
  watch:
  {
    operationListOutput: function()
    {
      this.loadingOperations = false;
    },
    comparativeData: function()
    {
      this.loadingComparativeData = false;
    }
  }  
}
</script>

<style scoped>

.alert-text
{
  opacity: 0.8;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  display: block;
}

.alert-text.show-all
{
  white-space: normal;
}

.button-container
{
  height: min-content;
}

.button-container button
{
  min-width: 80px;
}

.chart
{
  height: 20vh;
  min-height: 300px;
  width: 100%;
}

</style>